import { render, staticRenderFns } from "./PrintPreviewWithoutHeader.vue?vue&type=template&id=01641994"
import script from "./PrintPreviewWithoutHeader.vue?vue&type=script&lang=js"
export * from "./PrintPreviewWithoutHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01641994')) {
      api.createRecord('01641994', component.options)
    } else {
      api.reload('01641994', component.options)
    }
    module.hot.accept("./PrintPreviewWithoutHeader.vue?vue&type=template&id=01641994", function () {
      api.rerender('01641994', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/printpreview/PrintPreviewWithoutHeader.vue"
export default component.exports